/**
 * Action id constants for sticky header. Used by type modules and by StickyMenu to map to handlers/icons.
 */
export const ACTION_IDS = {
  MULTISTORE: "multistore",
  CALCULATOR: "calculator",
  CALCULATIONS: "calculations",
  LOGS: "logs",
  REPORTS: "reports",
  DISPENSING: "dispensing",
  SETTINGS: "settings",
  USERS: "users",
  ACCESS_SYSTEM_TICKETS: "accessSystemTickets",
  LOGOUT: "logout",
};
